import { powerMap } from "@/publicData/powerData";

export const configMenu = [
  { // 欢迎使用
    name:'欢迎使用',id:'welcome',icon:'el-icon-guide',sub: [{son:[
      {name:'welcome',componentName:'欢迎使用'},
    ],name:''}],
    isPower:true,
  },{ // 乡村振兴管理系统
    name:'乡村振兴管理系统',id:'xiangcun',icon:'el-icon-medal',sub:[{son:[
      {name:'http://xczx.3g48.com/ay_sys/',type:'outUrl',componentName:'智慧乡村'},
      {name:'http://xczx.3g48.com/ay_sys/index.php?m=do&f=user&a=login4',type:'outUrl',componentName:'智慧社区'},
      {name:'/fuwu?areaId=13267&type=gouwu&page=1',type:'localUrl',componentName:'电商',id:powerMap.gouwu},
      {name:'/fuwu?areaId=13267&type=meishi&page=1',type:'localUrl',componentName:'美食',id:powerMap.meishi},
      {name:'/fuwu?areaId=13267&type=lvyou&page=1',type:'localUrl',componentName:'旅游',id:powerMap.lvyou},
      {name:'/fuwu?areaId=13267&type=jiankang&page=1',type:'localUrl',componentName:'健康',id:powerMap.jiankang},
    ],name:''}],
    isPower:true,
  },{ // 就业扶贫管理系统
    name:'就业扶贫管理系统',id:'basic2',icon:'el-icon-document',sub: [{son:[
      {name:'form_gyxjdbfzb',componentName:'扶贫结对帮扶管理',id:powerMap.form_gyxjdbfzb},
      {name:'form_jyfpjd',componentName:'就业扶贫基地管理',id:powerMap.form_jyfpjd},
      {name:'form_pkhxx',componentName:'一户一档信息管理',id:powerMap.form_pkhxx},
      {name:'helpInfo',componentName:'帮扶干部扶贫管理'} // 通过账户的属性,判断该模块是否显示
    ],name:''}],
    isPower:true,
  },{ // 数据分类采集系统
    name:'数据分类采集系统',id:'basic',icon:'el-icon-document',sub: [{son:[
      {name:'Form_grxxcj',componentName:'个人信息采集管理',id:powerMap.Form_grxxcj},
      {name:'form_gwxxgxqkb',componentName:'用工信息采集管理',id:powerMap.form_gwxxgxqkb},
      {name:'form_axdw',componentName:'爱心单位采集管理',id:powerMap.form_axdw},
      {name:'form_dlgkbb',componentName:'独立工矿报表管理',id:powerMap.form_dlgkbb},
      // {name:'form_tyjryb',componentName:'退役军人月报管理',id:powerMap.form_tyjryb},
      // {name:'form_danweizp',componentName:'单位招聘统计表',id:powerMap.form_danweizp},
      {name:'form_ncldlzyjyhcyqkb',componentName:'农村劳动力转移就业和创业情况表',id:powerMap.form_ncldlzyjyhcyqkb},
    ],name:''}],
    isPower:true,
  },{ // 数据统计报表系统
    name:'数据统计报表系统',id:'sjtjbb',icon:'el-icon-receiving',sub:[{son:[
      // {name:'report_rsyw',componentName:'人社业务报表',id:powerMap.report_rsyw},
      // {name:'report_grxx',componentName:'个人信息报表',id:powerMap.report_grxx},
      {name:'report_grnlwhfx',componentName:'个人年龄文化分析',id:powerMap.report_grnlwhfx},
      {name:'report_grjyfsfx',componentName:'个人就业方式分析',id:powerMap.report_grjyfsfx},
      {name:'report_grjyqtfx',componentName:'个人就业群体分析',id:powerMap.report_grjyqtfx},
      {name:'report_grjyqyfx',componentName:'个人就业区域分析',id:powerMap.report_grjyqyfx},
      {name:'report_dwzpxqfx',componentName:'单位招聘需求分析',id:powerMap.report_dwzpxqfx},
      {name:'report_gqjgtxfx',componentName:'供求结构体系分析',id:powerMap.report_gqjgtxfx},
    ],name:''}],
    isPower:true,
  },{ // 云讯发布管理系统
    name:'云讯发布管理系统',id:'basic4',icon:'el-icon-paperclip',sub: [{son:[
      {name:'http://jcyx.3g48.com',type:'outUrl',componentName:'云讯发布'},
    ],name:''}],
    isPower:true,
  },{ // 人社数据同步系统
    name:'人社数据同步系统',id:'basic3',icon:'el-icon-paperclip',sub: [{son:[
      {name:'shengting_qiye',componentName:'同步企业信息',id:powerMap.shengting_qiye},
      {name:'shengting_gangwei',componentName:'同步岗位信息',id:powerMap.shengting_gangwei},
      {name:'shengting_zhaopinhui',componentName:'同步招聘会信息',id:powerMap.shengting_zhaopinhui},
      {name:'shengting_zhaopingangwei',componentName:'同步招聘会招聘岗位信息',id:powerMap.shengting_zhaopingangwei},
      // {name:'',type:'outUrl',componentName:'人社业务',id:powerMap.rensheyewu},
    ],name:''}],
    isPower:true,
  },{ // 残疾就业管理系统
    name:'残疾就业管理系统',id:'canjiren',icon:'el-icon-document',sub: [{son:[
      {name:'canjiren_jynldwjycjrzkdcb',componentName:'就业年龄段未就业残疾人状况调查表',id:powerMap.canjiren_jynldwjycjrzkdcb},
    ],name:''}],
    isPower:true,
  },{ // 退役军人管理系统
    name:'退役军人管理系统',id:'tuiyijunren',icon:'el-icon-document',sub: [{son:[
      {name:'tuiyijunren_tyjrjyqkcjb',componentName:'退役军人就业情况采集表',id:powerMap.tuiyijunren_tyjrjyqkcjb},
      {name:'tuiyijunren_tyjryb',componentName:'退役军人月报管理',id:powerMap.tuiyijunren_tyjryb},
    ],name:''}],
    isPower:true,
  },{ // 人口进城管理系统
    name:'人口进城管理系统',id:'basic5',icon:'el-icon-document',sub: [{son:[
      {name:'questionnaire_jionCity',componentName:'人口进城调查',id:powerMap.questionnaire_jionCity},
    ],name:''}],
    isPower:true,
  },{ // 补贴台账
    name:'智慧人社服务系统',id:'form3',icon:'el-icon-document',sub: [{son: [
      {name:'form_ygdxbttjb',componentName:'以工代训补贴统计表',id:powerMap.form_ygdxbttjb},
      {name:'form_ycxqzcybttjb',componentName:'一次性求职创业补贴统计表',id:powerMap.form_ycxqzcybttjb},
      {name:'form_jtbttjb',componentName:'交通补贴统计表',id:powerMap.form_jtbttjb},
      {name:'form_gwsbbttjb',componentName:'岗位、社保补贴统计表',id:powerMap.form_gwsbbttjb},
      {name:'form_pxbthshfbt',componentName:'培训补贴和生活费补贴',id:powerMap.form_pxbthshfbt},
      {name:'form_btqkztjb',componentName:'补贴情况总统计表',id:powerMap.form_btqkztjb},
    ],name:''}],
    isPower:true,
  },{ // 工作台账
    name:'工作台账管理系统',id:'form4',icon:'el-icon-document',sub: [{son: [
      {name:'form_gyxgwaztjb',componentName:'公益性岗位安置统计表',id:powerMap.form_gyxgwaztjb},
      {name:'form_jyfpcjtjb',componentName:'就业扶贫车间统计表',id:powerMap.form_jyfpcjtjb},
      {name:'form_rycctjb',componentName:'人员抽查统计表',id:powerMap.form_rycctjb},
      {name:'form_mbrwtjb',componentName:'目标任务统计表',id:powerMap.form_mbrwtjb},
      {name:'form_rlzysczytjb',componentName:'人力资源市场主要统计表',id:powerMap.form_rlzysczytjb},
      {name:'form_nclwjjr',componentName:'农村劳务经纪人统计表',id:powerMap.form_nclwjjr},
      {name:'form_nclwjjrbtsb',componentName:'农村劳务经纪人补贴申报统计表',id:powerMap.form_nclwjjrbtsb},
      {name:'form_rlzyfwjg',componentName:'人力资源服务机构统计表',id:powerMap.form_rlzyfwjg},
      {name:'form_rlzyfwjgbtsb',componentName:'人力资源服务机构补贴申报统计',id:powerMap.form_rlzyfwjgbtsb},
      {name:'form_jycyfwbttjb',componentName:'就业创业服务补贴统计表(导出)',id:powerMap.form_jycyfwbttjb},
      {name:'form_gwcctjb',componentName:'岗位抽查统计表',id:powerMap.form_gwcctjb},
      {name:'form_czsyrytjb',componentName:'城镇失业人员统计表',id:powerMap.form_czsyrytjb},
    ],name:''}],
    isPower:true,
  },{ // 就业日志管理系统
    name:'就业日志管理系统',id:'fupinrizhi',icon:'el-icon-document-copy',sub:[{son:[
      {name:'log',componentName:'结对帮扶管理',id:powerMap.log},
      {name:'log1',componentName:'信息采集管理',id:powerMap.log1},
      {name:'log2',componentName:'就业服务管理',id:powerMap.log2},
      {name:'log3',componentName:'培训服务管理',id:powerMap.log3},
      {name:'log4',componentName:'创业服务管理',id:powerMap.log4},
      {name:'log5',componentName:'维权服务管理',id:powerMap.log5},
      {name:'log6',componentName:'其他服务管理',id:powerMap.log6},
      {name:'log7',componentName:'我的日志管理'}, // 完全依附于 个人信息采集管理模块 是否显示,个人信息采集管理模块显示,此模块就显示
      {name:'log_shengcha',componentName:'服务日志审计',id:powerMap.log_shengcha},
    ],name:''}],
    isPower:true,
  },{ // 现场远程创业系统
    name:'现场远程创业系统',id:'fupinchejian',icon:'el-icon-school',sub:[{son:[
      {name:'form_jyfpcjjbqkzb',componentName:'就业扶贫车间基本情况汇总表',id:powerMap.form_jyfpcjjbqkzb},
      {name:'form_jyfpcjxnjymc',componentName:'就业扶贫车间吸纳就业名册汇总表',id:powerMap.form_jyfpcjxnjymc},
      {name:'form_jyfpcjdtgl',componentName:'就业扶贫车间动态管理台帐',id:powerMap.form_jyfpcjdtgl},
      {name:'form_xnpkldljydtjgtz',componentName:'吸纳贫困劳动力就业动态监管台账',id:powerMap.form_xnpkldljydtjgtz},
      {name:'form_xnydbqpkndl',componentName:'吸纳易地变迁贫困劳动力就业名册',id:powerMap.form_xnydbqpkndl},
    ],name:''}],
    isPower:true,
  },{ // 视频招聘求职系统
    name:'视频招聘求职系统',id:'work',icon:'el-icon-suitcase',sub:[{son:[
      {name:'/fuwu?areaId=&type=qiuzhi&page=1',type:'localUrl',componentName:'求职',id:powerMap.qiuzhi},
      {name:'/fuwu?areaId=&type=zhaopin&page=1',type:'localUrl',componentName:'招聘',id:powerMap.zhaopin1},
    ],name:''}],
    isPower:true,
  },{ // 远程培训服务系统
    name:'远程培训服务系统',id:'peixun',icon:'el-icon-data-line',sub:[{son:[
      {name:'studyUpload',componentName:'培训上传',id:powerMap.studyUpload},
      {name:'studyApply',componentName:'培训申请',id:powerMap.studyApply},
      {name:'studyExamine',componentName:'培训审核',id:powerMap.studyExamine},
      {name:'studyList',componentName:'培训列表',id:powerMap.studyList},
      
    ],name:''}],
    isPower:true,
  },{ // 企业服务管理系统
    name:'企业服务管理系统',id:'jingcheng',icon:'el-icon-office-building',sub:[{son:[
      {name:'companyApply',componentName:'企业申请审核',id:powerMap.companyApply},
      {name:'jiaoyu',componentName:'教育服务列表',id:powerMap.jiaoyu},
      {name:'peixun',componentName:'培训服务列表',id:powerMap.peixun},
      {name:'zhaoshang',componentName:'招商服务列表',id:powerMap.zhaoshang},
      {name:'jiameng',componentName:'加盟服务列表',id:powerMap.jiameng},
      {name:'rongzi',componentName:'融资服务列表',id:powerMap.rongzi},
      {name:'touzi',componentName:'投资服务列表',id:powerMap.touzi},
      {name:'zufang',componentName:'租房服务列表',id:powerMap.zufang},
      {name:'shoufang',componentName:'售房服务列表',id:powerMap.shoufang},
      {name:'qiche',componentName:'汽车服务列表',id:powerMap.qiche},
      {name:'gouwu',componentName:'电商服务列表',id:powerMap.gouwu},
      {name:'meishi',componentName:'美食服务列表',id:powerMap.meishi},
      {name:'lvyou',componentName:'旅游服务列表',id:powerMap.lvyou},
      {name:'jiankang',componentName:'健康服务列表',id:powerMap.jiankang},
    ],name:''}],
    isPower:true,
  },{ // 人岗自动匹配系统
    name:'人岗自动匹配系统',id:'qiuzhizhaopin',icon:'el-icon-wallet',sub:[{son:[
      {name:'lookInterview',componentName:'查看面试邀请',id:powerMap.lookInterview},
      {name:'lookResume',componentName:'查看简历投递',id:powerMap.lookResume},
    ],name:''}],
    isPower:true,
  },{ // 法律维权管理系统
    name:'法律维权管理系统',id:'falvweiquan',icon:'el-icon-umbrella',sub:[{son:[
      {name:'flzx',componentName:'法律咨询',id:powerMap.flzx},
      {name:'ajwt',componentName:'案件委托',id:powerMap.ajwt},
      {name:'layerApply',componentName:'律师申请审核',id:powerMap.layerApply},
      {name:'layer',componentName:'律师服务列表'},
      {name:'',type:'outUrl',componentName:'政策法规'},
    ],name:''}],
    isPower:true,
  // },{ // 法律援助管理系统
  //   name:'法律援助管理系统',id:'falvyuanzhu',icon:'el-icon-umbrella',sub:[{son:[
  //     {name:'yz_wt_weituo',componentName:'委托合同',id:''},
  //     {name:'yz_wt_fapiao',componentName:'发票申领',id:'Entrust-invoice'},
  //   ],name:'案件委托'},{son:[
  //     {name:'yz_tj_tiaojie',componentName:'调解申请',id:'Encase-Contract'},
  //   ],name:'诉前调解'},{son:[
  //     {name:'yz_ss_baoquan',componentName:'诉讼保全',id:'Encase-Contract'},
  //     {name:'yz_ss_qubaohoushen',componentName:'取保候审',id:'Encase-Contract'},
  //     {name:'yz_ss_gongzheng',componentName:'公证鉴定',id:'Encase-Contract'},
  //     {name:'yz_ss_jinzhan',componentName:'诉讼进展',id:'LitigationProgress'},
  //   ],name:'诉讼服务'},{son:[
  //     {name:'yz_ws_zhengju',componentName:'证据资料上传',id:'LitigationDoc'},
  //     {name:'yz_ws_caijue',componentName:'裁判文书上传',id:'LitigationDoc'},
  //     {name:'yz_ws_zongjie',componentName:'案件总结上传',id:'LitigationDoc'},
  //     {name:'yz_ws_guidang',componentName:'案件资料归档',id:'LitigationDoc'},
  //   ],name:'诉讼文书'}],
  //   // ],name:'案件委托'}],
  //   isPower:true,
  },{ // 信息发布管理系统
    name:'信息发布管理系统',id:'article',icon:'el-icon-edit-outline',sub:[{son:[
      {name:'briefIntroduction',componentName:'竞成简介',id:powerMap.briefIntroduction},
      {name:'idea',componentName:'竞成理念',id:powerMap.idea},
      {name:'culture',componentName:'竞成文化',id:powerMap.culture},
      {name:'team',componentName:'竞成团队',id:powerMap.team},
      {name:'routeLine',componentName:'竞成之路',id:powerMap.routeLine},
      {name:'contactUs',componentName:'联系我们',id:powerMap.contactUs},
    ],name:'关于竞成'},{son:[
      {name:'news',componentName:'竞成新闻',id:powerMap.news},
      {name:'activity',componentName:'竞成活动',id:powerMap.activity},
    ],name:'竞成动态'},{son:[
      {name:'overallArticle',componentName:'竞成声明和帮助',id:powerMap.overallArticle},
    ],name:'竞成声明和帮助'},],
    isPower:true,
  },{ // 人事人才管理系统
    name:'人事人才管理系统',id:'renshirencai',icon:'el-icon-edit-outline',sub:[{son:[
      {name:'banner_rs',componentName:'人事服务轮播管理',id:powerMap.banner_rs},
      {name:'banner_xw',componentName:'新闻中心轮播管理',id:powerMap.banner_xw},
    ],name:'轮播管理'},{son:[
      {name:'examination',componentName:'人事招考',id:powerMap.examination},
      {name:'archives',componentName:'人事档案',id:powerMap.archives},
      {name:'information',componentName:'人事信息',id:powerMap.information},
      {name:'train',componentName:'人事培训',id:powerMap.train},
    ],name:'人事服务'},{son:[
      {name:'notice',componentName:'才市预告',id:powerMap.notice},
      {name:'scene',componentName:'现场招聘',id:powerMap.scene},
      {name:'video',componentName:'视频招聘',id:powerMap.video},
    ],name:'人才超市'},{son:[
      {name:'interview',componentName:'在线访谈',id:powerMap.interview},
      {name:'interviewNotice',componentName:'访谈预告',id:powerMap.interviewNotice},
      {name:'interviewRecording',componentName:'访谈录播',id:powerMap.interviewRecording},
      {name:'leaderEmail',componentName:'领导信箱',id:powerMap.leaderEmail},
      {name:'knowAll',componentName:'百事通',id:powerMap.knowAll},
    ],name:'互动交流'},
    {son:[
      {name:'newsCenter',componentName:'新闻中心',id:powerMap.newsCenter},
    ],name:'新闻中心'},],
    isPower:true,
  },{ // 交流投诉管理系统
    name:'交流投诉管理系统',id:'complaint',icon:'el-icon-service',sub:[{son:[
      {name:'communication',componentName:'交流管理',id:powerMap.communication},
      {name:'complaint',componentName:'投诉管理',id:powerMap.complaint},
    ],name:''}],
    isPower:true,
  },{ // 个人社保服务系统
    name:'个人社保服务系统',id:'shebao',icon:'el-icon-monitor',sub:[{son:[
      {name:'shebao_geren',componentName:'个人社保信息管理',id:powerMap.shebao_geren},
      {name:'shebao_weizhuanyi',componentName:'未转移社保管理',id:powerMap.shebao_weizhuanyi},
      {name:'shebao_bujiaofei',componentName:'社保补缴费管理',id:powerMap.shebao_bujiaofei},
      {name:'shebao_jiaona',componentName:'缴纳情况管理',id:powerMap.shebao_jiaona},
      {name:'shebao_tuifei',componentName:'社保退费管理',id:powerMap.shebao_tuifei},
    ],name:''}],
    isPower:true,
  },{ // 工作人员服务系统
    name:'工作人员服务系统',id:'gongzuorenyuan',icon:'el-icon-suitcase-1',sub:[{son:[
      {name:'qiye',componentName:'企业管理'},
      {name:'fapiao',componentName:'发票管理',id:powerMap.fapiao},
      {name:'zhan_song',componentName:'送站管理'},
      {name:'zhan_jie',componentName:'接站管理'},
    ],name:''}],
    isPower:true,
  },{ // 人力资源管理系统
    name:'人力资源管理系统',id:'rlzy',icon:'el-icon-receiving',sub:[{son:[
      {name:'rlzy_guanlian_qiye',componentName:'关联企业管理',id:powerMap.rlzy_guanlian_qiye},
      {name:'rlzy_guanlian_geren',componentName:'关联个人管理',id:powerMap.rlzy_guanlian_geren},
      {name:'rlzy_dengji_hesuan',componentName:'费用核算发放登记',id:powerMap.rlzy_dengji_hesuan},
      {name:'rlzy_dengji_kaipiao',componentName:'开票登记',id:powerMap.rlzy_dengji_kaipiao},
      {name:'rlzy_dengji_daozhang',componentName:'到账登记',id:powerMap.rlzy_dengji_daozhang},
    ],name:''}],
    isPower:true,
    isPower:true,
  },{ // 建筑工地管理系统
    name:'建筑工地管理系统',id:'jzgd',icon:'el-icon-receiving',sub:[{son:[
      {name:'jzgd_zaixianqiuzhu',componentName:'在线求助',id:''},
      {name:'jzgd_zaixianqiuzhuM',componentName:'在线求助管理',id:powerMap.jzgd_zaixianqiuzhuM},
      {name:'jzgd_yonggongbeian',componentName:'劳动用工备案',id:powerMap.jzgd_yonggongbeian},
    ],name:''}],
    isPower:true,
  // },{ // 省厅数据对接系统
  //   name:'省厅数据对接系统',
  //   id:'shengting ',
  //   icon:'el-icon-s-custom',
  //   sub:[{son:[
  //     {name:'shengting_qiye',componentName:'企业信息',id:powerMap.shengting_qiye},
  //     {name:'shengting_gangwei',componentName:'岗位信息',id:powerMap.shengting_gangwei},
  //     {name:'shengting_zhaopinhui',componentName:'招聘会信息',id:powerMap.shengting_zhaopinhui},
  //     {name:'shengting_zhaopingangwei',componentName:'招聘会招聘岗位信息',id:powerMap.shengting_zhaopingangwei},
  //   ],name:''}],
  //   isPower:true,
// },{ // 快速求职管理系统
  //   name:'快速求职管理系统',
  //   id:'quickqiuzhi ',
  //   icon:'el-icon-s-custom',
  //   sub:[{son:[
  //     {name:'quickqiuzhi',componentName:'快速求职',id:powerMap.quickqiuzhi},
  //   ],name:''}],
  //   isPower:true,
  },{ // 个人中心
    name:'账户信息管理系统',id:'user',icon:'el-icon-user',sub:[{son:[
      {name:'userInfo',componentName:'个人信息展示'},
      {name:'companyInfo',componentName:'企业信息展示'},
      {name:'sendResume',componentName:'发送的简历投递'},
      {name:'getInterview',componentName:'收到的面试邀请'},
      {name:'sendInterview',componentName:'发出的面试邀请'},
      {name:'getResume',componentName:'收到的简历投递'},
      {name:'editPwd',componentName:'修改密码'},
      {name:'hetong',componentName:'合同管理'},
      {name:'zhan_song_',componentName:'送站信息'},
      {name:'zhan_jie_',componentName:'接站信息'},
      {name:'gongzi',componentName:'工资信息'},
    ],name:''}],
    isPower:true,
  },{ // 报表设置管理系统
    name:'报表设置管理系统',id:'chart',icon:'el-icon-document',sub:[{son:[
      {name:'chart',componentName:'报表设置'}
    ],name:''}],
    isPower:true,
  },{ // 系统设置管理系统
    name:'系统设置管理系统',id:'system',icon:'el-icon-setting',sub:[
      {son:[
        {name:'logo',componentName:'分站设置',id:powerMap.logo},
        {name:'mapSet',componentName:'地图信息',id:powerMap.mapSet},
        {name:'areaedit',componentName:'地区修改',id:powerMap.areaedit},
        {name:'setKeyWord',componentName:'设置评论敏感词',id:powerMap.setKeyWord},
        {name:'subsite',componentName:'站点管理'}, // 除管理员外,没有任何账号有此权限.完全独立,不依靠任何权限
      ],name:'系统配置'},
      {son:[
        {name:'fenzhan',componentName:'创建用户',id:powerMap.fenzhan},
        {name:'power',componentName:'权限和密码设置',id:powerMap.power},
        {name:'role',componentName:'角色管理'}, // 依附于 上面这个权限
        {name:'vip',componentName:'VIP申请管理',id:powerMap.vip},
      ],name:'用户设置'},
      {son:[
        {name:'zhengce',componentName:'政策法规',id:powerMap.zhengce},
        {name:'renshe',componentName:'人社业务',id:powerMap.renshe},
        {name:'movie',componentName:'远程视频'} // 还未确定
      ],name:'链接管理'},
      {son:[
        {name:'password',componentName:'密码修改'}, // 管理员的密码和信息修改才在系统设置里面
        {name:'selfinfo',componentName:'个人信息'}, // 管理员的密码和信息修改才在系统设置里面
      ],name:'密码设置'}],
    isPower:true,
  },
]






